import { Stack, Typography } from "@mui/material";
import { CopyButton } from "Components/_Shared/Buttons/CopyButton";
import { HStack } from "Components/_Shared/Core/Stack";
import { Configuration } from "Infrastructure/Config/config";
import { Spacing } from "Infrastructure/Themes/Themes";
import { Resources, useResource } from "Infrastructure/Translations/Resources";

export const DevToolsHome = () => {
  const { t } = useResource();

  const rows = [
    { label: t(Resources.DevTools.Home.BranchName), value: Configuration.getBranchName() },
    { label: t(Resources.DevTools.Home.CommitMessage), value: Configuration.getCommitMessage() },
  ];

  return (
    <Stack spacing={Spacing.M}>
      {rows.map(({ label, value }) => (
        <HStack key={label} spacing={Spacing.S} alignItems="center">
          <Typography variant="body2" color="text.secondary" flexShrink={0}>
            {label}
          </Typography>
          <Typography variant="body2" fontFamily="monospace" sx={{ overflowWrap: "anywhere" }}>
            {value}
          </Typography>
          <CopyButton text={value} />
        </HStack>
      ))}
    </Stack>
  );
};
